import { DeckPermissionsUserRole } from '~~/entities/deck'

/** Null/undefined is treated as non-elevated (e.g. missing deck role on current user). */
export function isElevatedDeckRole(role: DeckPermissionsUserRole | null | undefined): boolean {
  if (role == null) return false
  return role === DeckPermissionsUserRole.Owner || role === DeckPermissionsUserRole.Editor
}

/** Maps API role to the share-picker option id (Viewer | Editor) for dropdown model binding. */
export function sharePickerRoleFromApiRole(role: DeckPermissionsUserRole): DeckPermissionsUserRole {
  return isElevatedDeckRole(role) ? DeckPermissionsUserRole.Editor : DeckPermissionsUserRole.Viewer
}

// Viewer stays Viewer; API owner and legacy editor both show as Editor in the share UI.
export function displayDeckRoleLabel(role: DeckPermissionsUserRole): string {
  const labels: Record<DeckPermissionsUserRole, string> = {
    [DeckPermissionsUserRole.Viewer]: 'Viewer',
    [DeckPermissionsUserRole.Editor]: 'Editor',
    [DeckPermissionsUserRole.Owner]: 'Editor',
  }
  return labels[role]
}

// UI "Editor" maps to API owner.
export function apiRoleFromSharePickerRole(role: DeckPermissionsUserRole): DeckPermissionsUserRole {
  if ([DeckPermissionsUserRole.Editor, DeckPermissionsUserRole.Owner].includes(role)) return DeckPermissionsUserRole.Owner
  return DeckPermissionsUserRole.Viewer
}

export const shareDialogPickerRoles = [DeckPermissionsUserRole.Viewer, DeckPermissionsUserRole.Editor] as const
